"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (map) { return Array.from(map)
    .reduce(function (obj, _a) {
    var _b;
    var key = _a[0], value = _a[1];
    return Object.assign(obj, (_b = {}, _b[key] = value, _b));
}, {}); });
//# sourceMappingURL=convertMapToObject.js.map